import Swiper from "swiper";
import { Navigation, Pagination, A11y } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".image-popover-swiper").forEach((element) => {
    new Swiper(element, {
      modules: [Navigation, Pagination, A11y],
      slidesPerView: 1.2,
      autoHeight: true,
      breakpoints: {
        500: {
          slidesPerView: 2.2,
          autoHeight: false,
        },
        800: {
          slidesPerView: 3.2,
        },
        1089: {
          virtualTranslate: true,
          spaceBetween: 0,
        }
      },
      breakpointsBase: 'container',
      spaceBetween: 16,
      simulateTouch: false,
      watchOverflow: false,
      navigation: {
        enabled: true,
        prevEl: element.closest(".swiper-parent").querySelector(".swiper-navigation .prev"),
        nextEl: element.closest(".swiper-parent").querySelector(".swiper-navigation .next"),
      },
      pagination: {
        enabled: true,
        el: element.closest(".swiper-parent").querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  });
});
